import { createRoot } from "react-dom/client";
import App from "./App";
import { hydrateBlogInitialData } from "./lib/blogInitialData";
import "./index.css";

hydrateBlogInitialData();
createRoot(document.getElementById("root")!).render(<App />);
